import { SET_ALL_ENUMS } from './types';

export const enumsMutations = {
  [SET_ALL_ENUMS](state, payload) {
    state.allEnums = payload;
  },
};
